import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import PersonRelationshipTypeList from "./PersonRelationshipTypeList";

export default {
  list: PersonRelationshipTypeList,
  icon: AccessibilityNewIcon,
};
